import { useEffect, useState } from 'react';
import { fetchCachedLottieJson } from 'utils/lottieJson';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LottieData = any;

export type LottieLoadStatus = 'idle' | 'loading' | 'loaded' | 'error';

export const useLottieJsonWithStatus = (url?: string | null) => {
  const [data, setData] = useState<LottieData | null>(null);
  const [status, setStatus] = useState<LottieLoadStatus>('idle');

  useEffect(() => {
    let cancelled = false;

    const raw = typeof url === 'string' ? url.trim() : '';
    if (!raw) {
      setData(null);
      setStatus('idle');
      return;
    }

    setStatus('loading');

    fetchCachedLottieJson(raw)
      .then((json) => {
        if (cancelled) return;
        setData(json);
        setStatus(json ? 'loaded' : 'error');
      })
      .catch(() => {
        // fetchCachedLottieJson already normalizes errors; keep UI safe.
        if (cancelled) return;
        setData(null);
        setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return { data, status };
};

export const useLottieJson = (url?: string | null) => {
  return useLottieJsonWithStatus(url).data;
};
